import React, { useEffect } from 'react';
import LoadingSpinner from 'components/common/loading-spinner';
import serverProxy from 'cvat-core/src/server-proxy';
import { useHistory } from 'react-router-dom';
import { notification } from 'antd';

const GoogleAuthCallback = () => {
    const history = useHistory();

    useEffect(() => {
        const authenticate = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const key = urlParams.get('key');

            if (key !== null) {
                await serverProxy.server.setAuthData({
                    headers: {},
                    data: { key }
                } as any);
                notification.success({
                    message: 'Successfully logged in'
                });
                window.location.href = '/projects';
                return;
            } else {
                const isUserAlreadyRegistered = urlParams.get('already');
                const isUserNotFound = urlParams.get('not_found');

                console.log('states: ', [isUserAlreadyRegistered, isUserNotFound]);

                if (isUserAlreadyRegistered != null) {
                    notification.error({
                        message: 'User already registered. Try again'
                    });
                    window.location.href = '/auth/login';
                    return;
                }

                if (isUserNotFound != null) {
                    notification.error({
                        message: 'User not found. Try again'
                    });
                    window.location.href = '/auth/register';
                    return;
                }

                notification.error({
                    message: 'Error during Google authentication'
                });
                window.location.href = '/auth/login';
            }
        };

        authenticate();
    }, [history]);

    return <LoadingSpinner />;
};

export default GoogleAuthCallback;
